module.exports = __webpack_public_path__ + "static/media/btbms_mobile_hero_fr.f67afcb2.jpg";